const configOkta = {
    clientId: '0oakbkga3wF0al9CF1t7',
    issuer: 'https://brightcove.okta.com/',
    redirectUri: `${window.location.origin}/vet/portfolio/sign-in/callback`,
    scopes: ['openid', 'profile', 'email'],
    pkce: true
};

export default configOkta;
